export const DEVICE_CATEGORIES = {
    CONTROLLER: 1,
    TERMINAL: 2,
    INPUT_OUTPUT: 3,
    READER: 4,
    BIOMETRIC_READER: 5,
    BIOMETRIC_CONTROLLER: 6,
    EL_LOCK_ENTRY: 7,
    EL_LOCK_EXIT: 8,
    LOCK: 9
}

export const CONTROLLER_TYPE_NUMBERS = {
    EC3: 150
}
